import * as React from 'react';
import TextField from '@mui/material/TextField';
import { TimeTextComponent } from '../TimeTextComponent';

interface TimePickerCustomProps {
    modify: boolean | undefined;
    time: string | undefined;
    onTimeChange: Function;
}
export function TimePickerCustom({
    modify,
    time,
    onTimeChange
}: TimePickerCustomProps): JSX.Element {
    return (
        <>
            {modify ? (
                <TextField
                    id="time"
                    type="time"
                    value={time}
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{
                        step: 300
                    }}
                    sx={{ width: 116 }}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
                        onTimeChange(event.target.value);
                    }}
                />
            ) : (
                <TimeTextComponent name="time" type="text" value={time} width="100%" />
            )}
        </>
    );
}
